import type { LucideIcon } from 'lucide-react';
import { CreditCard, Drama, Gavel, RefreshCcw, Star } from 'lucide-react';

export const riskTypeMapper = {
  chargebacks: { title: 'Chargebacks', Icon: RefreshCcw },
  contentFindings: { title: 'Content Findings', Icon: CreditCard },
  reputational: { title: 'Reputational', Icon: Star },
  transactionLaundering: { title: 'Transaction Laundering', Icon: Drama },
  legal: { title: 'Legal Risk', Icon: Gavel },
} satisfies Record<
  'chargebacks' | 'contentFindings' | 'reputational' | 'transactionLaundering' | 'legal',
  { title: string; Icon: LucideIcon }
>;
